<template>
  <div>
    <div class="list">
      <div class="item content">
        <div class="body">
          <div class="statistic" v-if="list.length > 0">
            <div class="name" v-for="item in list" :key="item.id">
              <span class="priority-badge" :class="{ 'priority-high': item.status === 'high', 'priority-medium': item.status === 'middle', 'priority-low': item.status === 'low' }"></span>
              <span class="status" :style="{ color: item.status === 'high' ? '#ff6b6b' : item.status === 'middle' ? '#ffc107' : '#00ff96' }">{{ item.status === 'high' ? '高': item.status === 'middle' ? '中': '低' }}</span>
              <span>{{ item.name }}</span>
              <span style="margin-left: auto;">{{ item.remark }}</span>
              <span style="margin-left: auto;color: rgba(255,255,255,0.7)">{{ item.createTime }}</span>
            </div>
          </div>
          <div v-else>
              <div style="display: flex;align-items: center;justify-content: center;height: 100%;">
                  <span style="font-size: 1.5vh;color: rgba(255,255,255,0.7)">暂无数据</span>
              </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchAlertList } from "@/api/alert";
export default {
  data() {
    return {
      list: [],
    };
  },

  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      fetchAlertList({
        pageNum: 1,
        pageSize: 10,
      }).then((res) => {
        if (res && Array.isArray(res.list)) {
          this.list = Object.freeze(res.list);
         //todo 待修改
          this.list = []
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.list {
  display: flex;
  align-items: flex-start;

  .item {
    flex-shrink: 0;

    .header {
      font-size: 1.6vh;
      font-weight: bold;
      color: rgba(0, 0, 0, 0.75);
      display: flex;
      align-items: center;
    }

    .body {
      display: flex;
      color:#fff;
      .statistic {
        flex: 1;
      }

      .value {
        span:first-child {
          font-size: 1.5em;
          padding-right: 0.2vw;
        }

        span:last-child {
          font-size: 1.2vh;
        }
      }
    }
  }
}

.content {
  flex: 1;
}
.name {
  font-size: 1.6vh;
  display: flex;
  align-items: center;
  height: 35px;
}
.status{
  margin-right: 10px;
}
.priority-badge {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 0.5rem;
}

.priority-high {
  background: #ff6b6b;
  box-shadow: 0 0 8px rgba(255, 107, 107, 0.5);
}

.priority-medium {
  background: #ffc107;
  box-shadow: 0 0 8px rgba(255, 193, 7, 0.5);
}

.priority-low {
  background: #00ff96;
  box-shadow: 0 0 8px rgba(0, 255, 150, 0.5);
}
</style>